/*
 * vv-designonline-return.js — Design Online → product-page continuation.
 *
 * Only PRODUCT_PAGE products (ITORIS custom-size: corflute, flute board, and the
 * "Custom Size" branch of the hybrids) are routed from /pages/design-online to their
 * product page with ?designOnline=1. Without this, the customer lands on a normal
 * product page with no obvious way back into designing. This adds that obvious step:
 *
 *   1. A clear sticky banner: set your size/options, then continue to the designer.
 *   2. A prominent "Continue to the designer" button that calls the page's existing
 *      __vvGalleryGo() — the SAME launch the "Design with AI" button uses — so the
 *      chosen product + variant are carried into create.vividads.com.au.
 *   3. The page's existing "Design with AI" CTA is highlighted so it's unmissable.
 *   4. Where a standard size calculator exposes width/height (#vacp [data-w]/[data-h]),
 *      those are appended to the gallery URL as &w=&h=. (ITORIS custom dimensions render
 *      inside the ITORIS app and are a tool-side handshake, not read here.)
 *
 * Gated entirely on ?designOnline=1 — does nothing on a normal product page. Isolated:
 * namespaced .vvret-* styles, no theme files touched beyond one <script> tag.
 */
(function () {
  "use strict";
  try { if (!/[?&]designOnline=1\b/.test(location.search)) return; } catch (e) { return; }

  // ---- extend __vvGalleryUrl to carry width/height when a size calculator exposes them ----
  function wireGeometry() {
    if (typeof window.__vvGalleryUrl !== "function" || window.__vvGalleryUrl.__vvGeo) return;
    var orig = window.__vvGalleryUrl;
    var wrapped = function () {
      var url = orig.apply(this, arguments);
      try {
        var w = document.querySelector("#vacp input[data-w]"), h = document.querySelector("#vacp input[data-h]");
        if (w && h && w.value && h.value && url.indexOf("&w=") === -1) {
          url += "&w=" + encodeURIComponent(w.value) + "&h=" + encodeURIComponent(h.value);
        }
      } catch (e) {}
      return url;
    };
    wrapped.__vvGeo = true;
    window.__vvGalleryUrl = wrapped;
  }

  function go() {
    wireGeometry();
    if (typeof window.__vvGalleryGo === "function") { window.__vvGalleryGo(); return true; }
    if (typeof window.__vvGalleryUrl === "function") { location.href = window.__vvGalleryUrl(); return true; }
    return false;
  }

  function injectBanner() {
    if (document.getElementById("vvret-banner")) return;
    var css = document.createElement("style");
    css.textContent =
      "#vvret-banner{position:sticky;top:0;z-index:1200;background:#D6202B;color:#fff;font-family:Inter,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;" +
      "display:flex;align-items:center;gap:14px;flex-wrap:wrap;justify-content:center;padding:11px 18px;box-shadow:0 2px 10px rgba(0,0,0,.14)}" +
      "#vvret-banner .vvret-txt{font-size:14.5px;font-weight:600;line-height:1.35}" +
      "#vvret-banner .vvret-step{opacity:.9;font-weight:500}" +
      "#vvret-banner .vvret-go{appearance:none;border:0;cursor:pointer;background:#fff;color:#b81b25;font-weight:800;font-size:14px;" +
      "padding:9px 18px;border-radius:8px;white-space:nowrap;font-family:inherit}" +
      "#vvret-banner .vvret-go:hover{background:#ffe9ea}" +
      "#vvret-banner .vvret-x{background:none;border:0;color:#fff;opacity:.8;font-size:20px;line-height:1;cursor:pointer;padding:0 2px;margin-left:2px}" +
      "@media(max-width:640px){#vvret-banner{padding:10px 14px;gap:9px}#vvret-banner .vvret-txt{font-size:13px;flex:1 1 100%}#vvret-banner .vvret-go{flex:1 1 auto}}" +
      "@keyframes vvretPulse{0%,100%{box-shadow:0 0 0 0 rgba(214,32,43,.45)}50%{box-shadow:0 0 0 7px rgba(214,32,43,0)}}" +
      ".vvret-highlight{animation:vvretPulse 1.6s ease-out 3;border-radius:10px}";
    document.head.appendChild(css);

    var bar = document.createElement("div");
    bar.id = "vvret-banner";
    bar.innerHTML =
      '<span class="vvret-txt">✨ You’re designing online — <span class="vvret-step">choose your size and options below, then continue to the designer.</span></span>' +
      '<button type="button" class="vvret-go">Continue to the designer &rarr;</button>' +
      '<button type="button" class="vvret-x" aria-label="Dismiss">&times;</button>';
    (document.body || document.documentElement).insertBefore(bar, (document.body || document.documentElement).firstChild);

    bar.querySelector(".vvret-go").addEventListener("click", function () {
      if (!go()) { // launcher not ready yet — retry briefly
        var t0 = Date.now(); var iv = setInterval(function () { if (go() || Date.now() - t0 > 6000) clearInterval(iv); }, 200);
      }
    });
    bar.querySelector(".vvret-x").addEventListener("click", function () { bar.remove(); });

    // highlight the existing "Design with AI" CTA so the on-page route is obvious too
    try {
      var cta = [].slice.call(document.querySelectorAll(".vv-cta--canvas, .vv-cta, button, a"))
        .find(function (el) { return el.offsetParent && /design with ai/i.test(el.textContent || ""); });
      if (cta) { cta.classList.add("vvret-highlight"); }
    } catch (e) {}
  }

  function start() { wireGeometry(); injectBanner(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();
})();
